import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DynamicForm from './DynamicForm';
import HtmlPopup from '../../common/HtmlPopup';
import { format } from 'date-fns';
import { FaCheckCircle, FaSignature, FaSearchPlus } from 'react-icons/fa';
import { ProcessingOverlay } from '../../common/ProcessingOverlay';
import Swal from "sweetalert2";
import CustomDataTable from '../../common/CustomRichTable';
const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
  return `${process.env.REACT_APP_API_SECURITY_KEY}`;
};
const SubmittedFilesList = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null); // State for selected task
  const [isOpen, setIsOpen] = useState(false);
  const [templateContent, setTemplateContent] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAppImagesModalOpen, setIsAppImagesModalOpen] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const toggleDialog = () => {
    setIsOpen(!isOpen);
  };

  const fetchTemplate = async (fileDetailsId) => {
    setIsProcessing(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/client/office/getFileTemplate/${fileDetailsId}`,
        {
          headers: {
            'auth_key': `${getAuthKey()}`,
          }
        }
      );
      //console.log(response);
      const data = await response.data;
      //console.log(data);
      if (data.statusCode === 1001) {
        setTemplateContent(data.result);
        toggleDialog(); // Open the dialog after fetching content
      } else {
        setTemplateContent(data.result);
        toggleDialog(); // Open the dialog after fetching content
      }

    } catch (error) {
      console.error("Error fetching template:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const fetchTasks = async () => {
    setIsProcessing(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/client/office/getsubmittedfilesbyorganization/${localStorage.getItem('clientID')}`,
        {
          headers: {
            'auth_key': `${getAuthKey()}`,
          }
        }
      );
      const resultData = response.data.result;

      setTasks(resultData);
    } catch (err) {
      setError('Failed to fetch tasks');
    } finally {
      setLoading(false);
      setIsProcessing(false);
    }
  };

  useEffect(() => {

    fetchTasks();
  }, []);

  if (loading) {
    return <div>Loading Pending...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (selectedTask) {
    alert(selectedTask.fileId);
    // Render DynamicForm when a task is selected
    return <DynamicForm fileId={selectedTask.fileId} />;
  }

  const handleApprove = async (fileDetailsId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to approve this?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/client/office/approvefile?fileDetailsId=${fileDetailsId}&userId=${localStorage.getItem('userID')}`, {
          method: 'POST',
          headers: {
            'auth_key': `${getAuthKey()}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          alert('Network response was not ok');
          throw new Error('Network response was not ok');
        }

        const data = await response.json();// Check for specific status codes in the response
        if (data.statusCode === 1002) {
          // Returning a specific error message if the user already exists
          return { error: data.result };
        } else if (data.statusCode === 1001) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Successfully Approved",
            confirmButtonColor: "#4CAF50",
            allowOutsideClick: false, // Prevent closing by clicking outside
            allowEscapeKey: false,    // Prevent closing with the Escape key
          });
          return { success: "Updated Successfully" };
        } else if (data.statusCode === 1003) {
          Swal.fire("Error", "Failed to save data. " + data.result, "error");
          return { error: data.result };
        }
        else if (data.statusCode === 1004) {
          Swal.fire("Error", "Failed to save data. " + data.result, "error");
          return { error: data.result };
        } else {
          Swal.fire("Error", "An unexpected error occurred.", "error");
          return { error: 'Fail' };
        }
        alert(data);
        return data; // Return the API response
      } catch (error) {
        console.error('Error submitting form:', error);
        alert('Error submitting form:', error);
        throw error; // Re-throw the error for handling in the component
      } finally {
        fetchTasks();
      }
    }
  };

  // Function to Open Modal with Selected Images
  const openImageModal = (images) => {
    setSelectedImages(images);
    setIsModalOpen(true);
  };

  const columns = [
    { Header: 'Client', accessor: 'subClientName' },
    { Header: 'Checkin ID', accessor: 'checkinId' },
    { Header: 'Applicant', accessor: 'customerName' },
    { Header: 'Date', accessor: 'createdDate' },
    { Header: 'Executive', accessor: 'fieldOfficerName' },
    { Header: 'Component', accessor: 'componentName' },
    { Header: 'TAT', accessor: 'tat' },
    {
      Header: 'Signatures',
      accessor: 'signatures',
      Cell: ({ row }) => (
        <button
          className="text-blue-600 underline"
          onClick={() => openImageModal([row.customerSign, row.executiveSign])}
        >
          Show Signatures
        </button>
      ),
    },
    {
      Header: 'Approve',
      Cell: ({ row }) => (
        <button
          className="text-white bg-blue-500 hover:bg-blue-700 px-4 py-2 rounded-full"
          onClick={() => handleApprove(row.fileDetailsId)}
        >
          Approve
        </button>
      ),
    },
    {
      Header: 'View',
      Cell: ({ row }) => (
        <button
          className="p-2 bg-blue-500 text-white rounded-md"
          onClick={() => fetchTemplate(row.fileDetailsId)}
        >
          <FaSearchPlus />
        </button>
      ),
    },
  ];

  const openAppImageModal = (urls) => {
    setImageUrls(urls); // Set the image URLs
    setIsAppImagesModalOpen(true); // Open the modal
  };

  return (
    <div className="container mx-auto px-4">
      <h1 className="text-2xl font-bold mb-4">Pending List</h1>
      {tasks.length === 0 ? (
        <p>No tasks assigned</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto">
            <thead>
              <tr className="bg-gradient-to-r from-indigo-600 to-indigo-500 text-white shadow-md">
                <th className="px-2 py-3 text-xs md:text-sm font-semibold">Client</th>
                <th className="px-2 py-3 text-xs md:text-sm font-semibold">Checkin ID</th>
                <th className="px-2 py-3 text-xs md:text-sm font-semibold">Applicant</th>
                <th className="px-2 py-3 text-xs md:text-sm font-semibold">Date</th>
                <th className="px-2 py-3 text-xs md:text-sm font-semibold">Executive</th>
                <th className="px-2 py-3 text-xs md:text-sm font-semibold">Component</th>
                <th className="px-2 py-3 text-xs md:text-sm font-semibold">TAT</th>
                <th className="px-2 py-3 text-xs md:text-sm font-semibold">Signatures</th>
                <th className="px-2 py-3 text-xs md:text-sm font-semibold">Attachments</th>
                <th className="px-2 py-3 text-xs md:text-sm font-semibold">Approve</th>
                <th className="px-2 py-3 text-xs md:text-sm font-semibold">View</th>
              </tr>
            </thead>
            <tbody>
              {tasks.map((task, index) => {
                // Parse the date and format it to 'DD-MM-YYYY'
                const formattedDate = format(new Date(task.createdDate), 'dd-MM-yyyy');
                return (<tr key={task.taskId} className={`transition-all duration-300 ease-in-out 
                  ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} 
                  hover:bg-blue-50 hover:shadow-lg`}>
                  <td className="border px-4 py-2 text-xs md:text-sm">{task.subClientName}</td>
                  <td className="border px-4 py-2 text-xs md:text-sm">{task.checkinId}</td>
                  <td className="border px-4 py-2 text-xs md:text-sm">{task.customerName}</td>
                  <td className="border px-4 py-2 text-xs md:text-sm  whitespace-nowrap">{formattedDate}</td>
                  <td className="border px-4 py-2 text-xs md:text-sm">{task.fieldOfficerName}</td>
                  <td className="border px-4 py-2 text-xs md:text-sm">{task.componentName}</td>
                  <td className="border px-4 py-2 text-xs md:text-sm">{task.tat}</td>
                  <td className="border px-4 py-2 text-xs md:text-sm">
                    <button
                      onClick={() => openImageModal([task.customerSign, task.executiveSign])}
                      className="text-blue-600 underline"
                    >
                      Show Signatures
                    </button>
                  </td>
                  <td className="border px-4 py-2 text-xs md:text-sm">
                    <button
                      onClick={() => openAppImageModal(task.imageUrls)}
                      className="text-blue-600 underline"
                    >
                      Show Images
                    </button>
                  </td>
                  <td className="border px-4 py-2 text-xs md:text-sm">
                    <button
                      className="text-white bg-blue-500 hover:bg-blue-700 px-4 py-2 rounded-full"
                      onClick={() => {
                        handleApprove(task.fileDetailsId);
                      }}
                    >
                      Approve
                    </button>
                  </td>
                  <td className="border px-4 py-2 text-xs md:text-sm">

                    <button className="p-2 bg-blue-500 text-white rounded-md"
                      onClick={() => fetchTemplate(task.fileDetailsId)}
                    >
                      <FaSearchPlus />
                    </button>

                  </td>
                </tr>
                )
              })}
            </tbody>
          </table>
        </div>

      )}

      {/* <CustomDataTable columns={columns} data={tasks} /> */}
      <div>
        <HtmlPopup
          isOpen={isOpen}
          toggleDialog={toggleDialog}
          templateContent={templateContent}
        />
        {/* {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative bg-white w-11/12 max-w-4xl p-6 rounded shadow-lg overflow-auto max-h-screen">
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              onClick={toggleDialog}
            >
              ✖
            </button>

            <div className="template-content">
  <style>
    {`
      .template-content table { 
        width: 100%; 
        border-collapse: collapse; 
        border: 1px solid black; 
      }
      .template-content td, 
      .template-content th { 
        border: 1px solid black; 
        padding: 8px; 
        text-align: left; 
      }
    `}
  </style>
  <div dangerouslySetInnerHTML={{ __html: templateContent }} />
</div>

          </div>
        </div>
      )}  */}
      </div>
      {/* Modal Popup */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-4 rounded shadow-lg max-w-lg">
            <h2 className="text-lg font-semibold mb-4">Signatures</h2>
            {/* <div className="flex space-x-2"> */}

            {selectedImages &&
              <div className="space-y-2">
                <div>
                  <h2>Customer Signature</h2>
                  <img src={selectedImages[0]} alt="Preview" className="w-64 h-32 border rounded" />
                </div>
                <div>
                  <h2>Executive Signature</h2>
                  <img src={selectedImages[1]} alt="Preview" className="w-64 h-32 border rounded" />
                </div>
              </div>
            }

            <button
              onClick={() => setIsModalOpen(false)}
              className="mt-4 px-4 py-2 bg-red-500 text-white rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}
      {/* Render the modal */}
      <ImageModal
        isOpen={isAppImagesModalOpen}
        onClose={() => setIsAppImagesModalOpen(false)} // Close the modal
        imageUrls={imageUrls} // Pass the image URLs to the modal
      />
      {/* Display the overlay when processing */}
      <ProcessingOverlay isProcessing={isProcessing} message="Please wait, we're processing your request..." />
    </div>
  );
};

const ImageModal = ({ isOpen, onClose, imageUrls }) => {
  if (!isOpen) return null; // Don't render if not open

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-4/5 h-4/5 overflow-auto p-4 rounded shadow-lg">
        <button onClick={onClose} className="text-red-500">Close</button>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          {imageUrls && imageUrls.length > 0 ? (
            imageUrls.map((url, index) => (
              <img
                key={index}
                src={url}
                alt={`Image ${index + 1}`}
                className="w-full h-auto rounded"
              />
            ))
          ) : (
            <p className="text-gray-500 col-span-full text-center">No Images Available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubmittedFilesList;
